import { useState } from 'react';
import { roles, routes } from '../../constants';
import { ClickOutside } from '../common/ClickOutside';
import { NavBarSubItem } from './NavBarSubItem';
import { useHistory } from 'react-router-dom';
import { ShowFor } from '../access';
import { RoleActionBlocker } from '../access/RoleActionBlocker';
import { TradedPositionsCountBadge } from '../common/TradedPositionsCountBadge';
import { TradeStatus } from '../../types/trades/TradeStatus';
import { useAppSelector } from '../../effects/useAppSelector';

const allRolesWithoutArrangersClient = roles.getAllRolesExclude(roles.ArrangersClient);

export const SecondaryMarketMenuItem = () => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(false);
    const tradedPositionsCount = useAppSelector(state =>
        state.tradeConfirm.tradedPositions.filter(p => p.trade.status === TradeStatus.pending).length
    );

    const toggleExpanded = () => setExpanded(!expanded);

    const isActive = () => {
        const { pathname } = history.location;
        return pathname.includes('bwic-monitor') || pathname.includes('my-bwics') || pathname.includes(routes.inventory)
            ? 'active'
            : '';
    };

    return (
        <li className={`navbar-item dropdown dropdown-with-badge ${expanded ? 'show' : ''}`}>
            <button
                type="button"
                className={`btn-link navbar-link dropdown-toggle ${isActive()}`}
                onClick={toggleExpanded}
            >
                Secondary
            </button>
            <div className={`dropdown-menu navbar-dropdown-menu navbar-dropdown-manage ${expanded ? 'show' : ''}`}>
                {expanded && (
                    <ClickOutside onClick={() => setExpanded(false)}>
                        <>
                            <ShowFor roles={[roles.Administrator, ...roles.bd(), ...roles.seller(), roles.SellerAdministrator, roles.Viewer, roles.DataEntry, roles.ArrangersClient]}>
                                <RoleActionBlocker roles={allRolesWithoutArrangersClient}>
                                    <NavBarSubItem
                                        onClick={toggleExpanded}
                                        path={routes.allBWICs}
                                        title={(
                                            <>
                                                BWIC Monitor
                                                <TradedPositionsCountBadge tradedPositionsCount={tradedPositionsCount} />
                                            </>
                                        )}
                                    />
                                </RoleActionBlocker>
                            </ShowFor>
                            <ShowFor roles={roles.bd()}>
                                <NavBarSubItem
                                    onClick={toggleExpanded}
                                    path={routes.inventory}
                                    title="Inventory"
                                />
                            </ShowFor>
                            <ShowFor roles={[...roles.seller(), roles.Viewer, roles.Administrator, roles.DataEntry, roles.ArrangersClient]}>
                                <RoleActionBlocker roles={allRolesWithoutArrangersClient}>
                                    <NavBarSubItem
                                        onClick={toggleExpanded}
                                        path={routes.inventory}
                                        title="Dealer Inventory"
                                    />
                                </RoleActionBlocker>
                            </ShowFor>
                        </>
                    </ClickOutside>
                )}
            </div>
        </li>
    );
};
